// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"654":"dd830547","688":"5e352b75"}[chunkId] + ".chunk.css";
};